import { Navigate } from "react-router";
import type { AppRouteObject } from "./types";
import { lazyRoute } from "./lazyRoute";
import { withProjectRootMetadata } from "./featureRouteMetadata";
import * as Dtos from "src/dtos/Tmd.dtos";

export const projectRoutes = withProjectRootMetadata({
    path: "projects",
    handle: { help: null },
    children: [
        {
            index: true,
            lazy: lazyRoute(() => import("../containers/Projects/Projects/ProjectsPage")),
            handle: { help: { topicKey: "projects" } }
        },
        {
            path: "create",
            lazy: lazyRoute(() => import("../containers/Projects/Project/ProjectPage"), { context: "project", mode: "create" }),
            handle: { help: { topicKey: "project" } }
        },
        {
            path: ":projectId",
            handle: { help: null },
            children: [
                {
                    index: true,
                    element: <Navigate replace to="details" />,
                    handle: { help: null }
                },
                {
                    path: "details",
                    lazy: lazyRoute(() => import("../containers/Projects/Project/ProjectPage"), { context: "project", mode: "edit" }),
                    handle: { help: { topicKey: "project" } }
                },
                {
                    path: "items",
                    lazy: lazyRoute(() => import("../containers/Projects/ProjectItems/ProjectItemsPageSWR")),
                    handle: { help: { topicKey: "project-items" } }
                },
                {
                    path: "investigators",
                    handle: { help: null },
                    children: [
                        {
                            path: "create",
                            lazy: lazyRoute(() => import("../containers/Projects/ProjectInvestigator/ProjectInvestigatorPage"), { context: "project", mode: "create" }),
                            handle: { help: { topicKey: "project-investigator" } }
                        },
                        {
                            path: ":projectInvestigatorId",
                            handle: { help: null },
                            children: [
                                {
                                    index: true,
                                    element: (
                                        <Navigate replace to="details" />
                                    ),
                                    handle: { help: null }
                                },
                                {
                                    path: "details",
                                    lazy: lazyRoute(() => import("../containers/Projects/ProjectInvestigator/ProjectInvestigatorPage"), { context: "project", mode: "edit" }),
                                    handle: { help: { topicKey: "project-investigator" } }
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "discussions",
                    handle: { help: null, access: { permission: Dtos.Permission.ProjectDiscussionView } },
                    children: [
                        {
                            index: true,
                            lazy: lazyRoute(() => import("../containers/Projects/Discussions/DiscussionsPageSWR")),
                            handle: { help: { topicKey: "discussions" } }
                        },
                        {
                            path: "create",
                            lazy: lazyRoute(() => import("../containers/Projects/Discussion/DiscussionPageSWR"), { orientation: "project", mode: "create" }),
                            handle: { help: { topicKey: "discussion" } }
                        },
                        {
                            path: ":discussionId",
                            handle: { help: null, breadcrumb: null },
                            children: [
                                {
                                    index: true,
                                    element: (
                                        <Navigate replace to="details" />
                                    ),
                                    handle: { help: null }
                                },
                                {
                                    path: "details",
                                    lazy: lazyRoute(() => import("../containers/Projects/Discussion/DiscussionPageSWR"), { orientation: "project", mode: "edit" }),
                                    handle: { help: { topicKey: "discussion" } }
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
} satisfies AppRouteObject);

